module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.showWeekNumber),
      callback: function($$v) {
        _vm.showWeekNumber = $$v
      },
      expression: "showWeekNumber"
    }
  }, [_vm._v("Show week number")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.formatAmPm),
      callback: function($$v) {
        _vm.formatAmPm = $$v
      },
      expression: "formatAmPm"
    }
  }, [_vm._v("AM/PM")])], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('b-switch', {
    model: {
      value: (_vm.enableSeconds),
      callback: function($$v) {
        _vm.enableSeconds = $$v
      },
      expression: "enableSeconds"
    }
  }, [_vm._v("Enable seconds")])], 1)]), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Select datetime"
    }
  }, [_c('b-datetimepicker', {
    attrs: {
      "rounded": "",
      "placeholder": "Click to select...",
      "icon": "calendar-today",
      "datepicker": {
        showWeekNumber: _vm.showWeekNumber
      },
      "timepicker": {
        enableSeconds: _vm.enableSeconds,
        hourFormat: _vm.format
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b98ad312"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/datetimepicker/examples/ExSimple.vue
// module id = 1049
// module chunks = 18 138